var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { "data-component": "agent-profile-popup" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c("agent-profile-popup-info", {
        attrs: {
          avatar: _vm.avatar,
          agent: _vm.agent,
          "multi-user": _vm.multiUser,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "options" },
        [
          _vm._l(_vm.options, function (option) {
            return _c(
              "div",
              {
                key: option.key,
                attrs: { "data-option": option.key },
                on: {
                  click: function ($event) {
                    return _vm.$emit("option-click", option.key)
                  },
                },
              },
              [_vm._v("\n      " + _vm._s(option.label) + "\n    ")]
            )
          }),
          _vm._v(" "),
          _vm.options.length > 0
            ? _c("div", { staticClass: "divider" })
            : _vm._e(),
          _vm._v(" "),
          _c("theme-switcher"),
          _vm._v(" "),
          _c("div", { staticClass: "divider" }),
          _vm._v(" "),
          _c(
            "div",
            {
              attrs: { "data-option": "sign-out" },
              on: {
                click: function ($event) {
                  return _vm.$emit("sign-out")
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("HITL.common.labels.sign-out")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.appVersion
            ? _c("div", { staticClass: "app-version-label" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("HITL.common.labels.app-version", {
                        version: _vm.appVersion,
                      })
                    ) +
                    "\n    "
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }